import usePokemonSprites from '../../hooks/usePokemonSprites';
import './Top8Display.css';

export default function Top8Display({ standings = [], tournamentName = '', playerCount = '' }) {
  // Collect all unique pokemon IDs from all standings
  const allPokemon = standings
    .flatMap((s) => s.team)
    .filter((p) => p && p.trim() !== '');
  
  const { sprites, loading } = usePokemonSprites(allPokemon);

  if (!standings || standings.length === 0) {
    return (
      <div className="top8-display__empty">
        <p className="chiron-goround-tc-body">Aucun classement a afficher pour le moment.</p>
      </div>
    );
  }

  // Split standings into two columns: odd on left, even on right
  const column1 = standings.filter((_, i) => i % 2 === 0); // #1, #3, #5, #7
  const column2 = standings.filter((_, i) => i % 2 === 1); // #2, #4, #6, #8

  const renderEntry = (entry) => (
    <div key={`${entry.rank}-${entry.player}`} className={`top8-entry card ${entry.rank === 1 ? 'top8-entry--winner' : ''}`}>
      <div className="top8-entry__rank-badge">
        <span className="top8-entry__rank-number">#{entry.rank}</span>
      </div>

      {entry.score && (
        <div className="top8-entry__score-badge">
          <span className="top8-entry__score-text">{entry.score}</span>
        </div>
      )}

      <div className="top8-entry__player-section">
        <h3 className="top8-entry__player-name staatliches-regular">
          {entry.player}
        </h3>
      </div>

      {entry.team && entry.team.length > 0 && (
        <div className="top8-entry__team">
          {entry.team
            .filter((p) => p && p.trim() !== '')
            .map((pokemon, idx) => {
              const spriteUrl = sprites[pokemon.toLowerCase().trim()];
              return (
                <div key={`${entry.rank}-${idx}`} className="top8-entry__pokemon">
                  {spriteUrl ? (
                    <img
                      src={spriteUrl}
                      alt={pokemon}
                      className="top8-entry__sprite"
                      loading="lazy"
                    />
                  ) : (
                    <div className="top8-entry__sprite-placeholder">?</div>
                  )}
                  <span className="top8-entry__pokemon-name chiron-goround-tc-light">
                    {pokemon}
                  </span>
                </div>
              );
            })}
        </div>
      )}
    </div>
  );

  return (
    <div className="top8-standings-list">
      {(tournamentName || playerCount) && (
        <div className="top8-display__tournament-header">
          {tournamentName && (
            <h2 className="top8-display__tournament-name honk-title">{tournamentName}</h2>
          )}
          {playerCount && (
            <p className="top8-display__tournament-info chiron-goround-tc-light">
              {playerCount} Joueurs
            </p>
          )}
        </div>
      )}
      <div className="top8-standings__header">
        <span className="top8-standings__header-label chiron-goround-tc-light">
          Classement
        </span>
      </div>

      <div className="top8-standings__columns">
        <div className="top8-standings__column">
          {column1.map(renderEntry)}
        </div>
        <div className="top8-standings__column">
          {column2.map(renderEntry)}
        </div>
      </div>
    </div>
  );
}
